// Utility functions for Intercom integration

/**
 * Initialize Intercom for anonymous users
 */
const initializeAnonymousIntercom = () => {
  if (typeof window !== 'undefined') {
    // Check if Intercom script is already loaded
    if (!window.Intercom) {
      // Load Intercom script dynamically
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://widget.intercom.io/widget/rq48bo5h';
      
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      }

      // Initialize Intercom for anonymous users
      script.onload = () => {
        if (window.Intercom) {
          window.Intercom('boot', {
            app_id: 'rq48bo5h'
            // No user_id for anonymous users - Intercom will handle this
          });
        }
      };
    } else {
      // Intercom is already loaded, just boot for anonymous users
      window.Intercom('boot', {
        app_id: 'rq48bo5h'
      });
    }
    
    return true;
  }
  return false;
};

/**
 * Opens the Intercom messenger (works for both authenticated and anonymous users)
 */
export const openIntercom = () => {
  if (typeof window !== 'undefined') {
    if (window.Intercom) {
      window.Intercom('show');
    } else {
      // Try to initialize for anonymous users
      if (initializeAnonymousIntercom()) {
        // Wait a bit for initialization, then show
        setTimeout(() => {
          if (window.Intercom) {
            window.Intercom('show');
          }
        }, 1000);
      }
    }
  }
};

/**
 * Opens Intercom with a specific message (works for both authenticated and anonymous users)
 */
export const openIntercomWithMessage = (message: string) => {
  if (typeof window !== 'undefined') {
    if (window.Intercom) {
      window.Intercom('showNewMessage', message);
    } else {
      // Try to initialize for anonymous users
      if (initializeAnonymousIntercom()) {
        // Wait a bit for initialization, then show with message
        setTimeout(() => {
          if (window.Intercom) {
            window.Intercom('showNewMessage', message);
          }
        }, 1000);
      }
    }
  }
};

/**
 * Opens Intercom for sales inquiries (works for both authenticated and anonymous users)
 */
export const openIntercomForSales = () => {
  openIntercomWithMessage('Hi! I\'m interested in learning more about ShredsAI pricing and enterprise solutions.');
};

/**
 * Opens Intercom for support inquiries (works for both authenticated and anonymous users)
 */
export const openIntercomForSupport = () => {
  openIntercomWithMessage('Hi! I need help with ShredsAI. Can you assist me?');
};

/**
 * Check if Intercom is available
 */
export const isIntercomAvailable = (): boolean => {
  return typeof window !== 'undefined' && !!window.Intercom;
};